import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { saveAs } from 'file-saver';
import { Observable } from 'rxjs';
import { Part } from '../../opc-app/part/part.model';
import { ExportService } from '../../shared/services/export.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PartService } from '../../shared/services/part.service';

@Component({
  selector: 'app-export',
  templateUrl: './export.component.html',
  
})
export class ExportComponent implements OnInit {
 
  title = 'excel-upload-download';
  excel = [];
    partGroupID: number;
  loading = false;
    json: any;
  constructor(private exportService: ExportService, private http: HttpClient, private _partService: PartService, private spinner: NgxSpinnerService, private _route: ActivatedRoute) { }
  ngOnInit() {
    this.getParts();
  }

  getParts() {
    this.loading = true;
    this.spinner.show();
    this._partService.getAllPartsToExport().subscribe(res => {
      this.json=res;
      this.spinner.hide();
      this.loading = false;
    });
  }

  getTheFile(): void {    
    var listOfParts = [];
    var parts = this.json;
    var list = [];

    type partDetailsModel =
    {
      CreatedBy: '',
      CreatedDt: '',
      IsActive: '',
      IsDefault: '',
      IsServiceReimbursable: '',
      PartDesc: '',
      PartGroupDesc: '',
        ColorDesc: '',
        Code: '',
        CSSColorCode: '',
      PartEffectiveDate: '',
      PartEndDate: '',
      PartNumber: '',
      ReplacementPartID: '',
      Size: '',
      SupplierName: '',
        Quantity: '',
      PackageType:'',
      UpdatedBy: '',
      UpdatedDt: '',
      WarrantyPeriod: '',
      Handling: '',
      Length: '',
      Keywords: '',
      IsDiscontinued: '',
        Notes: '',
        WholesalePrice:'',
        ProductLineDesc: '',
        ProductFamilyDesc: '',
        VintageStart: '',
        VintageEnd:'',
        ProductFamilyName:''
      }
    
    for (let i = 0; i < parts.length; i++) {
      const partDetails = {} as partDetailsModel;  
            
      partDetails.CreatedBy = parts[i].createdBy;
      partDetails.CreatedDt = parts[i].createdDt;
      partDetails.IsActive = parts[i].isActive;
      partDetails.IsDefault = parts[i].isDefault;
      partDetails.IsServiceReimbursable = parts[i].isServiceReimbursable;
      partDetails.PartDesc = parts[i].partDesc;
      partDetails.PartGroupDesc = parts[i].partGroup.partGroupDesc;
      partDetails.ColorDesc = parts[i].colorCode.colorCodeDesc;
      partDetails.Code = parts[i].colorCode.code;
      partDetails.CSSColorCode = parts[i].colorCode.cssColorCode;
      partDetails.PartEffectiveDate = parts[i].partEffectiveDate;
      partDetails.PartEndDate = parts[i].partEndDate;
      partDetails.PartNumber = parts[i].partNumber;
      partDetails.ReplacementPartID = parts[i].replacementPartID;
      partDetails.Size = parts[i].size;
      partDetails.SupplierName = parts[i].supplierName;
      partDetails.Quantity = parts[i].quantity;
      partDetails.PackageType = parts[i].packageType;
      partDetails.UpdatedBy = parts[i].updatedBy;
      partDetails.UpdatedDt = parts[i].updatedDt;
      partDetails.WarrantyPeriod = parts[i].warrantyPeriod;
      partDetails.Handling = parts[i].handling;
      partDetails.Length = parts[i].length;
      partDetails.Keywords = parts[i].keywords;
      partDetails.IsDiscontinued = parts[i].isDiscontinued;
      partDetails.Notes = parts[i].notes;
      partDetails.WholesalePrice = parts[i].partPricing.wholesalePrice;
      partDetails.ProductFamilyName = parts[i].productFamily.productFamilyName;
      partDetails.ProductFamilyDesc = parts[i].productFamily.productFamilyDesc;
      partDetails.VintageStart = parts[i].productLine.vintageStart;
      partDetails.VintageEnd = parts[i].productLine.vintageEnd;
      partDetails.ProductLineDesc = parts[i].productLine.productLineDesc;
      list.push(i);
      listOfParts.push(partDetails);
    }


    
    this.exportService.exportAsCSVFile(listOfParts, "PartDetails")
   
  }

}




// WEBPACK FOOTER //
// ./src/opc/opc-admin/export/export.component.ts